export default "__VITE_ASSET__e1cb824b__"